export default __webpack_public_path__ + "static/0-f1162974795532ac6f3abbffc4b48447.png";